module.exports = __webpack_public_path__ + "img/download_solid.f74fb494.svg";